$(document).ready(function() {
    var IMAGE_INTERVAL = 7000;


    var resetAllSliders = function() {
        $('.timed-slider').each(function() {
            $(this).find('.clickable .progress').stop(true);
            $(this).find('.progress').css('width','0');
            $(this).find('.active').removeClass('active');
            $(this).find('.timer-element').first().addClass('active');
        });

        $('.with-timed-slider .images-list').each(function() {
            $(this).find('.active').removeClass('active');
            $(this).first().addClass('active');

            $(this).animate({
                scrollLeft: 0
            });
        })
    };

    /**
     * Stops all of the animations and then changes the image; and start the slider animation for the new image
     * @param el refers to the older image that is about to change
     */
    var nextSlider = function(sliderContainer, clickedOn) {
        // First, stop the slider animations for this container
        stopSliderAnimations(sliderContainer);
        sliderContainer.find('.timed-slider .timer-element.active span.progress').css('width', 0);

        changeToNextImage(sliderContainer);
        updateText(sliderContainer);

        // Starting the slider animation on the next one
        var active = sliderContainer.find('.timed-slider .timer-element.active').removeClass('active');
        var next = active.parent().next('.clickable').find('.timer-element');

        if (next.length) {
            next.addClass('active');
        } else {
            // Reached the end, need to get back to the first one
            sliderContainer.find('.timed-slider .timer-element').first().addClass('active');
        }

        // Start the sliders again
        runSliderAnimation(sliderContainer);
    };

    var changeToNextImage = function(sliderContainer) {
        // Getting the next image to move to
        var nextImage = sliderContainer.find('.images-list .image.active').removeClass('active').next('.image');
        if (nextImage.length) {
            nextImage.addClass('active');
        } else {
            // Set the first one to be the active image
            sliderContainer.find('.images-list .image').first().addClass('active');
        }

        switchToImage(sliderContainer);
    };

    var switchToImage = function(sliderContainer) {
        // Fade out the image
        sliderContainer.find('.image:not(".active")').animate({
            opacity: 0
        }, 100);

        var scrollLeftTo = sliderContainer.find('.images-list .image.active').position().left;
        if (scrollLeftTo > 0) {
            scrollLeftTo = '+=' + scrollLeftTo;
        } else {
            scrollLeftTo = '-=' + Math.abs(scrollLeftTo);
        }

        // Move to the active image
        sliderContainer.find('.side-image.with-timed-slider .images-list').animate({
            scrollLeft: scrollLeftTo
        }, 200, function() {
            sliderContainer.find('.image.active').animate({
                opacity: 1
            });
        });
    };

    /**
     * @param sliderContainer
     */
    var updateText = function(sliderContainer) {
        var active = sliderContainer.find('.text-container .description-box.active').removeClass('active');
        var next = active.next('.description-box');
        if (next.length) {
            next.addClass('active');
        } else {
            sliderContainer.find('.text-container .description-box').first().addClass('active');
        }
    };

    /** This will halt all animations for the slider */
    var stopSliderAnimations = function(sliderContainer) {
        sliderContainer.find('span.progress').stop(true);
    };

    /**
     * Starts the slider
     * @param sliderContainer
     */
    var runSliderAnimation = function(sliderContainer) {
        // updateSliderImageSizes();

        var progressEl = sliderContainer.find('.timed-slider .timer-element.active span.progress');
        if (progressEl) {
            progressEl.animate({
                width: '100%'
            }, IMAGE_INTERVAL, function () {
                nextSlider(sliderContainer);
            });
        }
    };

    $('.timed-slider').on('click', '.clickable', function() {
        // Checking that its not already running
        if (!$(this).find('.timer-element').hasClass('active')) {
            // Halting all animations for the sliderContainer
            $(this).parent().find('span.progress').stop(true).css('width', '0');

            // Getting the id of the slider element clicked on
            var id = $(this).attr('data-id');
            $(this).parent().find('.active').removeClass('active');
            $(this).parent().find('[data-id='+id+']').find('.timer-element').addClass('active');

            var sliderContainer = $(this).parent().parent().parent();
            sliderContainer.find('.images-list .active').removeClass('active');
            sliderContainer.find('.images-list .image[data-id='+id+']').addClass('active');

            sliderContainer.find('.description-box.active').removeClass('active');
            sliderContainer.find('.description-box[data-id=' + id + ']').addClass('active');

            runSliderAnimation(sliderContainer);
            switchToImage(sliderContainer);
        }
    });


    var isSliderInView = function(el) {
        var rect = el.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
            rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
        );
    };

    function updateSliderImageSizes() {
        $('.side-image').each(function() {
            var maxImgSize = $(this).find('.images-list').width()-20;
            $(this).find('img.scrollType').css('width', maxImgSize+'px');
        });
    };

    //Feature mouseover
    var highlightFeature = function(container) {
      console.log('feature mouse over');
      if(container) {
         $(container).addClass('highlight');
         $(container).find('.right-arrow').css('display', 'block');
      }
    };

    $('.feature-wrap').on('mouseover', function(e){
        highlightFeature(this);
    });
    $('.feature-wrap').on('mouseout', function(e){
        $(this).removeClass('highlight');
        $(this).find('.right-arrow').css('display', 'none');
    });

    $('.feature-wrap .right-arrow').on('click', function() {
       var section = $(this).closest('.feature-wrap').data('section');
        $('html, body').animate({
            scrollTop: (($('.section-'+section).offset().top)-60)
        },800);

    });

    //Fixed top header
    $(window).scroll(function () {
        if($(this).scrollTop() > 600) {
            $('.fixed-top').css('display', 'block');
        } else {
            $('.fixed-top').css('display', 'none');
        }
    });

    //Scrollable teachers
    $('.scrollable-teachers').on('click', '.left-arrow', function () {
        var width = $(window).width();
        var scrollWidth = $('.schools-landing-container .page-section.teachers .teachers-list .teacher').width()+20;
        if (width > 1000) {
            $('.schools-landing-container .page-section.teachers .teachers-list').animate({scrollLeft: '-=1000'})
        } else if (width > 700) {
            $('.schools-landing-container .page-section.teachers .teachers-list').animate({scrollLeft: '-=560'})
        } else {
            $('.schools-landing-container .page-section.teachers .teachers-list').animate({scrollLeft: '-=350'})
        }
    });

    $('.scrollable-teachers').on('click', '.right-arrow', function () {
        var width = $(window).width();
        var scrollWidth = $('.schools-landing-container .page-section.teachers .teachers-list .teacher').width()+20;
        if (width > 1000) {
            $('.schools-landing-container .page-section.teachers .teachers-list').animate({scrollLeft: '+=1000'})
        } else if (width > 700) {
            $('.schools-landing-container .page-section.teachers .teachers-list').animate({scrollLeft: '+=560'})
        } else {
            $('.schools-landing-container .page-section.teachers .teachers-list').animate({scrollLeft: '+='+ scrollWidth})
    }
    });


    //FAQ - show more
    if($('#faq-more').length) {
        var firstRowHeight = $('#faq-first').height() + parseInt($('#faq-first').css('paddingRight'));
        // $('.faq-wrap').css('height', firstRowHeight+'px');
        var current = $('.faq-wrap').offset().top + $('#faq-more').height();
        var expanded = $('#faq-more').offset().top + $('#faq-more').height();
        var increase = firstRowHeight + expanded - current;
        $('#faq-see-more').on('click', function(e){
            e.preventDefault();

            $('.faq-wrap').animate({height: increase+'px'});
            $(this).hide();
        });
    }

    // Start the slider
    runSliderAnimation($('.section-one'));
    runSliderAnimation($('.section-two'));
    runSliderAnimation($('.section-three'));
    updateSliderImageSizes();


    // adding tracking to the payment with credit card button:
    if($('.payment-form.credit-card-tab-details').length) {
        //this might be a race:
        $('.payment-form.credit-card-tab-details .stripeButton').on('click', function(e){
            if (window.Edu && window.Edu.trackEvent) {
                window.Edu.trackEvent(null, {}, {
                    eventCategory: 'school-account',
                    eventAction: 'cc-checkout',
                    eventLabel: 'cc-checkout',
                    metric1: 1
                });
            }
        });
    }

    //Request a quote form
    if($('.group-quote-data').length) {
        var groupQuote = new GroupQuote();

        function GroupQuote() {
            this.form = $('.group-quote-data');
            this.submitting = false;
            this.loadingOverlay = $(".purchase-order");
            this.purchaseOrderSubmit = $('.purchase-order-submit');
            var self = this;

            this.validateGroupQuoteForm = function(form, callback) {
                var hasErrors = false;
                var data = {};
                form.each(function (i, input) {
                    if (input.type === 'checkbox') {
                      data[input.name] = input.checked;
                    } else {
                      data[input.name] = input.value;
                    }
                    if (input.name === 'paymentType' && !input.value) {
                        hasErrors = true;
                        if (callback) {
                            callback({
                                status: false,
                                error: 'Please provide a payment type.'
                            });
                        }
                        return false;
                    }
                    if (input.type === 'email' && !(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value))) {
                        hasErrors = true;
                        if (callback) {
                            callback({
                                status: false,
                                error: 'The email you entered is invalid, please try again.'
                            });
                        }
                        return false;
                    }
                });
                if(!hasErrors) callback({status: true, data: data});
            }

          async function hashEmail(email) {
            if (!email) return '';

            const normalized = email.trim().toLowerCase();
            const encoder = new TextEncoder();
            const encodedEmail = encoder.encode(normalized);
            const hashBuffer = await crypto.subtle.digest('SHA-256', encodedEmail);
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            return hashArray.map((byte) => byte.toString(16).padStart(2, '0')).join('');
          }

            this.submit = function () {
                if (!this.submitting) {
                  this.resetForm();
                  this.setSubmitting(true);
                  this.validateGroupQuoteForm(this.form, async function(results) {
                      if (results && results.status) {
                          if (window.Edu && window.Edu.trackEvent) {
                            const safeEmail = results.data.email
                              ? await hashEmail(results.data.email)
                              : "";
                              window.Edu.trackEvent('School Sales Pages Tracking', {
                                  "page": "request quote page",
                                  "action": 'quote request submitted',
                                  'nameOfRequester': results.data.name,
                                  'emailOfRequester': safeEmail
                              }, {
                                  eventCategory: 'school-account',
                                  eventAction: 'submit-quote',
                                  eventLabel: 'submit-quote',
                                  metric1: 1
                              });
                          }
                          $.post('?', {
                                  __json: 'PurchaseOrder',
                                  action: 'emailAndMongoSave',
                                  data: results.data
                              }, groupQuote.processResponse
                          ).fail(function () {
                              groupQuote.processResponse({status: 0})
                          });
                      } else {
                          // There was an error
                          groupQuote.processResponse(results);
                          self.setSubmitting(false);
                      }
                  });
                }
            };

            this.setSubmitting = function (bool) {
                this.submitting = bool;
                if (bool) {
                    this.loadingOverlay.addClass('loading');
                    this.purchaseOrderSubmit.prop('disabled', true);
                    $('#purchase-order-submit').addClass('disabled');
                } else {
                    this.loadingOverlay.removeClass('loading');
                    this.purchaseOrderSubmit.prop('disabled', false);
                    $('#purchase-order-submit').removeClass('disabled');
                }
            };

            this.resetForm = function() {
                var errorDiv = $('#purchase-order-submit-error');
                errorDiv.text('');
            }

            this.processResponse = function (response) {
                if (response.status == 0) {
                    var errorDiv = $('#purchase-order-submit-error');
                    var errorMsg = (response.error ? response.error : 'There was an error submitting');
                    errorDiv.text(errorMsg);
                    errorDiv.removeClass('disabled');
                }
                else if (response.status == 1) {
                    var successModal = $('#request-quote-success');
                    if (successModal) {
                        successModal.modal('show');
                    }
                    // remove the form to prevent double entries:
                    var contactHtml = $('#contact-us-el').html();
                    $('#contact-form-holder').html("<h4>Your inquiry has been received. </h4><p>We will respond to you shortly. Thanks</p><div class='contact-us'>" + contactHtml + "</div>");
                }
            };

            this.handleAccountTypeOther = function () {
                var accountType = $('#purchase-order-account-type');
                var accountTypeOther = $('.account-type-other');

                if (accountType[0].value === "other-account") {
                    accountTypeOther.removeClass('disabled');
                } else {
                    if (!accountTypeOther.hasClass('disabled')) {
                        accountTypeOther.addClass('disabled');
                    }
                }
            };

            this.handlePaymentOther = function () {
                var paymentType = $('#purchase-order-payment-type');
                var paymentTypeOther = $('.payment-type-other');

                if (paymentType[0].value === "other-payment") {
                    paymentTypeOther.removeClass('disabled');
                } else {
                    if (!paymentTypeOther.hasClass('disabled')) {
                        paymentTypeOther.addClass('disabled');
                    }
                }
            };
        }

        $('#purchase-order-contact-form').on('submit', function (e) {
            e.preventDefault();
            groupQuote.submit();
        });

        $('#purchase-order-account-type').on('change', function () {
            groupQuote.handleAccountTypeOther();
        });

        $('#purchase-order-payment-type').on('change', function () {
            groupQuote.handlePaymentOther();
        });
    }
});
